import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onBeforeMount } from 'vue'
import Index from './index.vue'
import IndexOld from './index_old.vue'
import { isNeedNewFundUser } from '@/apis/fund'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const branchs = [
  IndexOld,
  Index
]
const index = ref(0)

onBeforeMount(() => {
  isNeedNewFundUser().then(res => {
    index.value = res.data ? 1 : 0
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(branchs[index.value])))
}
}

})